import React from 'react';
import { Input, InputProps } from '@SBGSports/catapult-core';
import { useTranslations } from 'i18n';
import styles from './search-box.module.css';

export type SearchBoxProps = Pick<
    InputProps,
    | 'value'
    | 'onChange'
    | 'onDebouncedChange'
    | 'debounceTime'
    | 'placeholder'
    | 'id'
    | 'testId'
    | 'disabled'
    | 'onBlur'
> & {
    wrapperClassName?: string;
};

export const SearchBox: React.FC<SearchBoxProps> = ({ wrapperClassName, placeholder, ...rest }) => {
    const { __ } = useTranslations();

    return (
        <div className={`${styles['child-border-override']} ${wrapperClassName ?? ''}`}>
            <Input
                {...rest}
                type="search"
                rightIcon="IconMagnifier"
                clearable
                placeholder={placeholder ?? `${__('misc.search')}...`}
            />
        </div>
    );
};
